import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { getText, isRtl, type Lang } from './translations';
export function DurationQuestionSlide({
  onSelect,
  onBack,
  lang = 'en' as Lang
}: {
  onSelect: (option: string) => void;
  onBack: () => void;
  lang?: Lang;
}) {
  const rtl = isRtl(lang);
  const options = [getText('lessThanWeek', lang), getText('oneToFourWeeks', lang), getText('oneToThreeMonths', lang), getText('moreThanThreeMonths', lang)];
  return <div className="flex flex-col h-full px-6 py-8 relative z-10 bg-white" dir={rtl ? 'rtl' : 'ltr'} data-id="element-117">
      {/* Blurry centered background image — atmospheric, no frame */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none flex items-center justify-center" data-id="element-118">
        <motion.img initial={{
        opacity: 0
      }} animate={{
        opacity: 0.25
      }} transition={{
        duration: 1.2
      }} src="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?q=80&w=1000&auto=format&fit=crop" className="w-[120%] h-[70%] object-cover object-center blur-sm" style={{
        WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)',
        maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)'
      }} alt="" data-id="element-119" />
      </div>

      <div className="flex items-center justify-between mb-8 relative z-10" data-id="element-120">
        <button onClick={onBack} className="p-2 -ml-2 text-slate-400 hover:text-stone-600 transition-colors bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-stone-100" aria-label="Go back" data-id="element-121">
          <ArrowLeftIcon className={`w-5 h-5 ${rtl ? 'rotate-180' : ''}`} data-id="element-122" />
        </button>
      </div>

      <div className="flex-1 flex flex-col max-w-sm mx-auto w-full relative z-10" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8" data-id="element-124">
          <h2 className="text-2xl font-semibold text-slate-900 leading-tight" data-id="element-125">
            {getText('durationQuestion', lang)}
          </h2>
        </motion.div>

        <div className="space-y-3 mt-auto mb-12" data-id="element-126">
          {options.map((option, index) => <motion.button key={option} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 + index * 0.1
        }} onClick={() => {
          setTimeout(() => onSelect(option), 150);
        }} className="w-full text-left p-5 rounded-xl border border-stone-200 bg-white shadow-sm hover:border-nhs-blue hover:ring-1 hover:ring-nhs-blue transition-all duration-200 group active:scale-[0.98]" data-id="element-127">
              <span className="text-stone-700 font-medium text-lg group-hover:text-nhs-blue transition-colors" data-id="element-128">
                {option}
              </span>
            </motion.button>)}
        </div>
      </div>
    </div>;
}